__turbopack_context__.v({
  "container": "SupportButton-module-scss-module__RMApHG__container",
  "inline": "SupportButton-module-scss-module__RMApHG__inline",
});
